export default __webpack_public_path__ + "static/media/egoeast_v2.86505e8e.jpg";